export default __webpack_public_path__ + "static/media/qa.634ce35b.gif";